<template>
  <canvas ref="root" class="ak-color-picker__preview" />
</template>

<script>
import { defineComponent, ref, watch, onMounted } from 'vue'
import colorPickerMixin from '../../mixins/colorPickerMixin'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-color-picker-preview />
   */
  name: 'AkColorPickerPreview',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    color: {
      type: String,
      default: '#000000',
    },

    width: {
      type: Number,
      default: 26,
    },

    height: {
      type: Number,
      default: 26,
    },
  },

  setup(props) {
    const alphaSize = ref(5)
    const mixin = colorPickerMixin()
    const root = ref(null)

    const renderColor = () => {
      const canvas = root.value
      const width = props.width
      const height = props.height
      const size = alphaSize.value
      const canvasSquare = mixin.createAlphaSquare(size)
      const ctx = canvas.getContext('2d')

      canvas.width = width
      canvas.height = height
      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat')
      ctx.fillRect(0, 0, width, height)
      ctx.fillStyle = props.color
      ctx.fillRect(0, 0, width, height)
    }

    watch(
      () => props.color,
      () => {
        renderColor()
      }
    )

    onMounted(() => {
      renderColor()
    })

    return {
      alphaSize,
      renderColor,
      root,
      ...mixin,
    }
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';
.ak-color-picker__preview {
  display: block;
  border-radius: $base-border-radius;
  border: $base-border;
}
</style>
